<ion-loading id="bulk-action-selector-loader" [isOpen]="isOpen()"></ion-loading>
<ion-button
  id="listOptions"
  size="small"
  fill="clear"
  color="dark"
  data-testid="bulkActionsEllipsis"
>
  <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
</ion-button>
<ion-popover
  trigger="listOptions"
  class="list-options-popover"
  [dismissOnSelect]="true"
>
  <ng-template>
    <h4>{{ title() | translate }}</h4>
    @for (button of buttons(); track button.nameKey) {
      <ion-button
        fill="clear"
        color="medium"
        (click)="setCurrentAction(button.bulkAction)"
        >{{ button.nameKey | translate }}</ion-button
      >
    }
  </ng-template>
</ion-popover>

@if (selectedBulkAction()) {
  <shared-fixed-confirm-message
    [isOkButtonDisabled]="amountSelected() === 0"
    (confirmOk)="invoke()"
    (confirmCancel)="cancelBulkAction()"
  >
    <span [ngPlural]="amountSelected()">
      <ng-template ngPluralCase="=0">{{
        page() + '_noBulkSelection' | translate
      }}</ng-template>
      <ng-template ngPluralCase="=1">
        <span>{{
          currentBulkActionMessage()?.singleSelected ?? '' | translate
        }}</span>
      </ng-template>
      <ng-template ngPluralCase="other">
        <span>{{
          currentBulkActionMessage()?.multipleSelected ?? ''
            | translate: { count: amountSelected() }
        }}</span>
      </ng-template>
    </span>
  </shared-fixed-confirm-message>
}
